import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const ConfigContext = createContext({
  config: null,
  loading: true,
  phiEnabled: false,
  billingEnabled: false,
});

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/config");
        setConfig(r.data);
      } catch {
        setConfig({
          phi_features_enabled: false,
          billing_enabled: false,
          product_name: "Nexari Health",
          product_tagline: "Track. Notify. Document.",
        });
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const value = {
    config,
    loading,
    phiEnabled: !!config?.phi_features_enabled,
    billingEnabled: !!config?.billing_enabled,
  };

  return <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>;
};

export const useConfig = () => useContext(ConfigContext);
